<div class="error-message" *ngIf="nombreError || clienteIdError">Por favor, cubra los campos obligatorios.</div>
<div class="error-message" *ngIf="nombreYaExisteError && (!nombreError && !clienteIdError)">El nombre del producto ya existe.</div>
<div class="error-message" *ngIf="showImageErrorMessage && (!nombreError && !clienteIdError && !nombreYaExisteError)">La imagen está en un formato incorrecto (solo JPG, JPEG o PNG).</div>
<div class="ok-message fade-out" *ngIf="!nombreError && !clienteIdError && cervezaCreada && !errorFinal">
    El producto se ha creado correctamente.
</div>
<div class="error-message fade-out" *ngIf="errorFinal">{{errorMessage}}</div>

<div class="container">
    <div class="header">
        <div class="header-content">
            <span  class="font20">NUEVO PRODUCTO DATABEER</span>
            <button mat-icon-button matTooltip="Registrar nuevo producto" class="gurdar-btn" (click)="guardarCliente()" [disabled]="waitAfterSave">
                <mat-icon>save</mat-icon>
            </button>
        </div>
        <span class="header-text" class="font14">Formulario de creación de tipos de cerveza DataBeer</span>
    </div>

    <div class="body">
        <form [formGroup]="signin" class="width100">
            <mat-form-field class="input-container">
                <mat-label class="label-text" [ngClass]="{'error-select': nombreError}">Nombre</mat-label>
                <input matInput placeholder="Nombre del producto" formControlName="nombre">
                <button *ngIf="nombreInput?.value" matSuffix mat-icon-button aria-label="Clear" (click)="clearField('nombre')">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
            <mat-error *ngIf="nombreError" class="custom1">El campo nombre no puede estar vacío</mat-error>
        </form>

        <div class="input-container2">
            <mat-label class="label-text" [ngClass]="{'error-select': clienteIdError}">Cliente</mat-label>
            <mat-form-field class="custom2" required>
                <mat-label [ngClass]="{'error-select': clienteIdError}">-Elige una opción-</mat-label>
                <mat-select [(value)]="selectedCliente" name="est">
                  <mat-option *ngFor="let est of clientes" [value]="est.value">
                    {{est.name}}
                  </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-error *ngIf="clienteIdError" class="custom3">Selecciona un cliente</mat-error>
        </div>

        <div class="imagen-container">
            <div>
                <p><span class="label-text">Imagen: </span><span>Imagen del nuevo producto (solo JPG, JPEG o PNG).</span></p>
            </div>
            <div>
                <button type="button" mat-raised-button (click)="fileInput.click()" class="boton-imagen">Elige una imagen</button>
                <span *ngIf="file !== undefined" class="marginLeft10">{{file.name}}</span>
            </div>
            <input hidden #fileInput type="file" id="image_uploads" (change)="onFileSelected($event)" accept="image/jpeg" class="custom4">
            <!--<div class="showImageErrorMessage-container" style="margin-top: 12px;">
                <span *ngIf="showImageErrorMessage" style="color: rgba(255, 0, 0, 0.993); font-size: 14px;">Por favor, seleccione un archivo .jpg</span>
            </div>-->
            <img *ngIf="imageUrl" [src]="imageUrl" alt="Vista previa de imagen establecimiento" class="imagen-dispositivo">
            <!--<img *ngIf="!imageUrl" src={{est_img_path}} alt="Vista previa de imagen establecimiento" class="imagen-dispositivo">-->
            <mat-error *ngIf="showImageErrorMessage" class="marginTop10">Por favor, seleccione un archivo .jpg .jpeg o .png</mat-error>
        </div>
    </div>
</div>
<div class="footer"></div>
